import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[bookshelfTemplateSubheader]',
})
export class BookshelfTemplateSubheaderDirective {
  constructor(public template: TemplateRef<any>) {
  }
}
